/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import WorkFlowProtocol from './work-flow-protocol';
import WorkFlowProtocolDetail from './work-flow-protocol-detail';
import WorkFlowProtocolUpdate from './work-flow-protocol-update';
import WorkFlowProtocolDeleteDialog from './work-flow-protocol-delete-dialog';

const WorkFlowProtocolRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<WorkFlowProtocol />} />
    <Route path="new" element={<WorkFlowProtocolUpdate />} />
    <Route path=":id">
      <Route index element={<WorkFlowProtocolDetail />} />
      <Route path="edit" element={<WorkFlowProtocolUpdate />} />
      <Route path="delete" element={<WorkFlowProtocolDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default WorkFlowProtocolRoutes;
